import React from 'react';
import PropTypes from 'prop-types';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const SideLine = ({
    isInModal = false
}) => {
    return (
        <div className={`layout-container-padding-right flex flex-wrap max-w-container rounded-md top-0 ${isInModal ? 'absolute -ml-10 h-full' : 'fixed h-screen'} z-20 select-none pointer-events-none`}>
            <div className='w-sidebar sidebar-border'/>
        </div>
    );
};


/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    isInModal: PropTypes.bool,
};

SideLine.propTypes = propTypes;

export default SideLine;
